import Spinner from 'components/spinner/Spinner';
import { Provider } from 'Provider';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import ErrorBoundary from 'ui/organism/error-handling/ErrorBoundary';
import PrivateRoute from './PrivateRoute';
import { fetchAuthStatus, fetchUser } from './redux/slices/usersSlice';

const SearchPage = React.lazy(() => import('features/v3/search/SearchPage'));

const SearchResultPage = React.lazy(() => import('features/v3/details/SearchResultPage'));
const DetailsContainer = React.lazy(() => import('features/details/DetailsContainer'));
const LoginPage = React.lazy(() => import('./LoginPage'));
const PageNotFound = React.lazy(() => import('features/page-not-found/PageNotFound'));

const App = () => {
  const dispatch = useDispatch();
  const { user, loading, authenticated } = useSelector((state) => state.users);
  
  useEffect(() => {
    !authenticated ? dispatch(fetchAuthStatus()) : dispatch(fetchUser());
  }, [dispatch, authenticated]);

  const path = useRef('/search');
  useEffect(() => {
    if (sessionStorage.getItem('redirect')) {
      path.current = sessionStorage.getItem('redirect');
      if (path.current === '/') {
        path.current = '/search';
      }
      sessionStorage.removeItem('redirect');
    }
  }, [path]);

  const msgFocusSearch = '';
  const [currentSearchFocus, setCurrentSearchFocus] = useState('');
  const [currentSearchDropdown, setCurrentSearchDropdown] = useState('people');
  const focusSearch = { msgFocusSearch, currentSearchFocus, setCurrentSearchFocus, currentSearchDropdown, setCurrentSearchDropdown };

  let content;

  if (loading) {
    content = <Spinner />;
  } else {
    content = (
      <Router>
        <React.Suspense fallback={null}>
          <ErrorBoundary user={user}>
            <Provider>
              <Switch>
                <Route exact path="/login" render={() => <LoginPage />} />
                <PrivateRoute path="/details/:type/:idType/:id" user={user}>
                  <DetailsContainer user={user} banner focusSearch={focusSearch} />
                </PrivateRoute>
                <PrivateRoute path="/results" user={user}>
                  <SearchResultPage focusSearch={focusSearch} user={user} banner />
                </PrivateRoute>
                <PrivateRoute path="/" exact user={user} focusSearch={focusSearch}>
                  <Redirect to={path.current} />
                </PrivateRoute>
                <PrivateRoute path="/search" user={user}>
                  <SearchPage focusSearch={focusSearch} user={user} />
                </PrivateRoute>
                <PrivateRoute path="*">
                  <PageNotFound user={user} focusSearch={focusSearch} />
                </PrivateRoute>
              </Switch>
            </Provider>
          </ErrorBoundary>
        </React.Suspense>
      </Router>
    );
  }

  return <>{content}</>;
};

export default App;
